import React, { memo } from 'react';
import useStatCardLogic from './useStatCardLogic';
import StatCardExpanded from './StatCardExpanded';
import StatCardCompact from './StatCardCompact';

const StatCard = memo(({
  title,
  value,
  icon: Icon,
  color,
  isAlert,
  showMarcasBreakdown = false,
  marcasData = null,
  onClick = null,
  isClickable = false,
  showCarAnimation = false,
  calculationTooltip = null,
  detailedMarcasData = null,
  iconPosition = 'bottom',
  type,
  facturadasCount,
  controlFacturadasCount,
  inventarioSinEscanearCount,
  facturadasPorLlegarCount,
  inventarioPorLlegarCount,
}) => {
  const logic = useStatCardLogic({
    isAlert,
    value,
    isClickable,
    onClick,
    showMarcasBreakdown,
    marcasData,
    iconPosition,
  });

  const segmentValues = {
    facturadasCount,
    controlFacturadasCount,
    inventarioSinEscanearCount,
    facturadasPorLlegarCount,
    inventarioPorLlegarCount,
  };

  const sharedProps = {
    title,
    value,
    icon: Icon,
    color,
    segmentValues,
    ...logic,
  };

  if (iconPosition === 'top' && showMarcasBreakdown && logic.sortedMarcasEntries) {
    return (
      <StatCardExpanded
        {...sharedProps}
        calculationTooltip={calculationTooltip}
        detailedMarcasData={detailedMarcasData}
      />
    );
  }

  return (
    <StatCardCompact
      {...sharedProps}
      showCarAnimation={showCarAnimation}
      showMarcasBreakdown={showMarcasBreakdown}
      type={type}
    />
  );
}, (prev, next) => {
  if (
    prev.title !== next.title ||
    prev.value !== next.value ||
    prev.color !== next.color ||
    prev.isAlert !== next.isAlert ||
    prev.isClickable !== next.isClickable ||
    prev.showCarAnimation !== next.showCarAnimation ||
    prev.showMarcasBreakdown !== next.showMarcasBreakdown ||
    prev.iconPosition !== next.iconPosition ||
    prev.facturadasCount !== next.facturadasCount ||
    prev.controlFacturadasCount !== next.controlFacturadasCount ||
    prev.inventarioSinEscanearCount !== next.inventarioSinEscanearCount ||
    prev.facturadasPorLlegarCount !== next.facturadasPorLlegarCount ||
    prev.inventarioPorLlegarCount !== next.inventarioPorLlegarCount ||
    prev.icon !== next.icon
  ) return false;

  if (prev.calculationTooltip !== next.calculationTooltip) {
    if (!prev.calculationTooltip || !next.calculationTooltip) return false;
    return false;
  }

  if (prev.detailedMarcasData !== next.detailedMarcasData) {
    if (!prev.detailedMarcasData || !next.detailedMarcasData) return false;
    if (prev.detailedMarcasData.length !== next.detailedMarcasData.length) return false;
    return false;
  }

  if (prev.isClickable && prev.onClick !== next.onClick) return false;

  if (prev.showMarcasBreakdown) {
    if (!prev.marcasData !== !next.marcasData) return false;
    if (prev.marcasData && next.marcasData) {
      const prevKeys = Object.keys(prev.marcasData);
      const nextKeys = Object.keys(next.marcasData);
      if (prevKeys.length !== nextKeys.length) return false;
      for (const key of prevKeys) {
        if (prev.marcasData[key] !== next.marcasData[key]) return false;
      }
    }
  }

  return true;
});

StatCard.displayName = 'StatCard';
export default StatCard;
